import { render, staticRenderFns } from "./NewFormSubmissionModal.vue?vue&type=template&id=1da681c3&"
import script from "./NewFormSubmissionModal.vue?vue&type=script&lang=js&"
export * from "./NewFormSubmissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports